export default "__VITE_ASSET__yGWDvnGf__"